module.exports = __webpack_public_path__ + "img/KSC07743.74edb312.jpg";